module.exports = __webpack_public_path__ + "static/media/4.015c6625.jpg";